// App.js
import { Routes, Route } from "react-router-dom"; 
import HomePage from "./pages/Homepage";
import PartnerRegistration from "./components/PartnerRegistration";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Naye Dynamic aur Detail components ko import kar rahe hain
import DynamicProductPage from "./components/DynamicProductPage";
import ProductDetails from "./components/ProductDetails"; // Yeh page hum abhi banayenge
import PartnerLogin from "./components/PartnerLogin";
import AdminDashboard from "./components/AdminDashboard";
import PartnerDashboard from "./components/PartnerDashboard";
import PrivacyPolicy from "./components/PrivacyPolicy";
import OrderManagement from "./components/OrderManagement";
import OrderPlacementPage from "./components/OrderPlacementPage";
import VendorProductForm from "./components/VendorProductForm";
import AdminPendingProducts from "./components/AdminPendingProducts";
import ProductsPage from "./components/ProductsPage";
import CartPage from "./components/CartPage";

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          {/* Home and Partner Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/partner" element={<PartnerRegistration />} />
          
          {/* 🎯 Single Dynamic Route: Yeh Imaging, Mobility aur NCN teeno ka kaam akele sambhalega */}
          <Route path="/products" element={<DynamicProductPage />} />
          <Route path="/category" element={<DynamicProductPage />} />

          {/* ⚡ Product Detail Route: Jab koi product card par double click karega */}
          <Route path="/product/:productId" element={<ProductDetails />} />
          <Route path="/login" element={<PartnerLogin/>}/>
          <Route path="/admin" element={<AdminDashboard/>}/>
          <Route path="/partner-dashboard" element={<PartnerDashboard/>}/>
          <Route path="/privacy" element={<PrivacyPolicy/>}/>
          <Route path="/order" element={<OrderManagement/>}/>
          <Route path="/checkout" element={<OrderPlacementPage/>}/>
          <Route path="/uploadproduct" element={<VendorProductForm/>}/>
          <Route path="/approve" element={<AdminPendingProducts/>}/>
          <Route path="/products" element={<ProductsPage/>}/>
          <Route path="/cart" element={<CartPage/>}/>
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;